"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionStorage = void 0;
const las_sdk_core_1 = require("@lucidtech/las-sdk-core");
class SessionStorage {
    constructor(keyName) {
        this.keyName = keyName || 'AuthToken';
    }
    getPersistentToken() {
        const tokenString = window.sessionStorage.getItem(this.keyName);
        if (!tokenString) {
            return null;
        }
        const { accessToken, expiration, refreshToken } = JSON.parse(tokenString);
        if (!(accessToken && expiration && refreshToken)) {
            return null;
        }
        return new las_sdk_core_1.Token(accessToken, expiration, refreshToken);
    }
    setPersistentToken(value) {
        const tokenString = JSON.stringify(value);
        window.sessionStorage.setItem(this.keyName, tokenString);
    }
}
exports.SessionStorage = SessionStorage;
